export default function ({ data, title }) {
  const xAxisValue = data.map(i => i.time)
  const seriesValue = data.map(i => i.value)
  return {
    title: {
      text: '',
      textStyle: {
        align: 'center',
        color: '#000',
        fontSize: 20
      },
      top: '3%',
      left: '10%'
    },
    backgroundColor: '#ffffff',
    grid: {
      top: '15%',
      bottom: '10%',
      left: '5%',
      right: '5%'
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['1234'],
      top: '10%',
      textStyle: {
        color: '#333'
      }
    },
    xAxis: {
      boundaryGap: false,
      data: xAxisValue,
      axisLine: {
        show: true, // 隐藏X轴轴线
        lineStyle: {
          // color: 'red'
        }
      },
      axisTick: {
        show: true,
        // interval: 0 // 可以设置成 0 强制显示所有标签， 如果设置为 1，表示隔一个标签显示一个标签
        lineStyle: {
          opacity: 0.8
        }

      },
      axisLabel: {
        show: true,
        textStyle: {
          color: '#333'
        }
      }

    },
    yAxis: [
      {
        type: 'value',
        name: title,
        nameTextStyle: {
          color: '#333'
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed',
            opacity: 0.5
          }
        },
        axisTick: {
          show: true
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: '#333'
          }
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: '#333'
          }
        }

      }
    ],
    series: [
      {
        name: '',
        type: 'line',
        yAxisIndex: 0, // 使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用
        smooth: true, // 平滑曲线显示
        showAllSymbol: true, // 显示所有图形。
        symbol: 'circle', // 标记的图形为实心圆
        symbolSize: 6, // 标记的大小
        itemStyle: {
          // 折线拐点标志的样式
          color: '#058cff'
        },
        lineStyle: {
          color: '#058cff'
        },
        // areaStyle: {
        //   color: 'rgba(5,140,255, 0.2)'
        // },
        data: seriesValue
      }
    ]
  }
}
